import React, { useState } from 'react';
import './Login.css';
import { authAPI } from '../utils/api';

function Login({ onLogin, onSwitchToSignup }) {
  const [formData, setFormData] = useState({
    identifier: '', // Discord username or email
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Determine if identifier is email or discord username
      const isEmail = formData.identifier.includes('@');
      const loginData = isEmail
        ? { email: formData.identifier, password: formData.password }
        : { discordUsername: formData.identifier, password: formData.password };

      const response = await authAPI.login(loginData.email, loginData.password, loginData.discordUsername);
      onLogin(response.user);
    } catch (err) {
      setError(err.message || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-modal-overlay">
      <div className="auth-modal">
        <div className="auth-modal-header">
          <h2>Login</h2>
          <button className="close-btn" onClick={() => onLogin(null)}>×</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="identifier">Discord Username or Email *</label>
            <input
              type="text"
              id="identifier"
              name="identifier"
              value={formData.identifier}
              onChange={handleChange}
              placeholder="username#1234 or email@example.com"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password *</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Enter your password"
              required
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
          <div className="auth-switch">
            Don't have an account?{' '}
            <button type="button" className="link-btn" onClick={onSwitchToSignup}>
              Sign Up
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;

